import FocusedPOIComponents from './FocusedPOIComponents';

export default FocusedPOIComponents;
